import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('niota-classic-devicetypes-create-edit-dialog', {
    attrs: {
      "isOpen": _vm.formDialog,
      "editedItem": _vm.editedItem
    },
    on: {
      "close": _vm.closeForm,
      "created": _vm.updateList
    }
  }), _c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('NiotaClassic.DeviceTypes.title'),
      "subtitle": "Devices-Types describe devices in a holistic way.",
      "buttons": _vm.deviceTypeButtons
    },
    on: {
      "addItem": _vm.addItem,
      "toggleAccountFilter": _vm.toggleAccountFilter,
      "toogleCertifiedFilter": _vm.toogleCertifiedFilter,
      "resetFilter": _vm.resetFilter
    }
  }), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', {
    attrs: {
      "title": null
    }
  }, [_c('niota-classic-devicetypes-list', {
    ref: "list",
    attrs: {
      "accountId": _vm.accountId,
      "findCertified": _vm.findCertified
    },
    on: {
      "edit-item": _vm.editItem
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };